/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TimeSeriesAlarm } from '../models/time-series-alarm';
@Injectable({
  providedIn: 'root',
})
class TimeSeriesAlarmService extends __BaseService {
  static readonly TimeSeriesAlarmCreatePath = '/api/TimeSeriesAlarm/Create';
  static readonly TimeSeriesAlarmUpdatePath = '/api/TimeSeriesAlarm/Update';
  static readonly TimeSeriesAlarmGetByUriPath = '/api/TimeSeriesAlarm/GetByUri/{uri}/{customerId}';
  static readonly TimeSeriesAlarmDeletePath = '/api/TimeSeriesAlarm/Delete';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param model undefined
   */
  TimeSeriesAlarmCreateResponse(model: TimeSeriesAlarm): __Observable<__StrictHttpResponse<TimeSeriesAlarm>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/TimeSeriesAlarm/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TimeSeriesAlarm>;
      })
    );
  }
  /**
   * @param model undefined
   */
  TimeSeriesAlarmCreate(model: TimeSeriesAlarm): __Observable<TimeSeriesAlarm> {
    return this.TimeSeriesAlarmCreateResponse(model).pipe(
      __map(_r => _r.body as TimeSeriesAlarm)
    );
  }

  /**
   * @param model undefined
   */
  TimeSeriesAlarmUpdateResponse(model: TimeSeriesAlarm): __Observable<__StrictHttpResponse<TimeSeriesAlarm>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/TimeSeriesAlarm/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TimeSeriesAlarm>;
      })
    );
  }
  /**
   * @param model undefined
   */
  TimeSeriesAlarmUpdate(model: TimeSeriesAlarm): __Observable<TimeSeriesAlarm> {
    return this.TimeSeriesAlarmUpdateResponse(model).pipe(
      __map(_r => _r.body as TimeSeriesAlarm)
    );
  }

  /**
   * @param params The `TimeSeriesAlarmService.TimeSeriesAlarmGetByUriParams` containing the following parameters:
   *
   * - `uri`:
   *
   * - `customerId`:
   */
  TimeSeriesAlarmGetByUriResponse(params: TimeSeriesAlarmService.TimeSeriesAlarmGetByUriParams): __Observable<__StrictHttpResponse<Array<TimeSeriesAlarm>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/TimeSeriesAlarm/GetByUri/${encodeURIComponent(String(params.uri))}/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TimeSeriesAlarm>>;
      })
    );
  }
  /**
   * @param params The `TimeSeriesAlarmService.TimeSeriesAlarmGetByUriParams` containing the following parameters:
   *
   * - `uri`:
   *
   * - `customerId`:
   */
  TimeSeriesAlarmGetByUri(params: TimeSeriesAlarmService.TimeSeriesAlarmGetByUriParams): __Observable<Array<TimeSeriesAlarm>> {
    return this.TimeSeriesAlarmGetByUriResponse(params).pipe(
      __map(_r => _r.body as Array<TimeSeriesAlarm>)
    );
  }

  /**
   * @param params The `TimeSeriesAlarmService.TimeSeriesAlarmDeleteParams` containing the following parameters:
   *
   * - `timeSeriesAlarmId`:
   *
   * - `customerId`:
   */
  TimeSeriesAlarmDeleteResponse(params: TimeSeriesAlarmService.TimeSeriesAlarmDeleteParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.timeSeriesAlarmId != null) __params = __params.set('timeSeriesAlarmId', params.timeSeriesAlarmId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/TimeSeriesAlarm/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `TimeSeriesAlarmService.TimeSeriesAlarmDeleteParams` containing the following parameters:
   *
   * - `timeSeriesAlarmId`:
   *
   * - `customerId`:
   */
  TimeSeriesAlarmDelete(params: TimeSeriesAlarmService.TimeSeriesAlarmDeleteParams): __Observable<Blob> {
    return this.TimeSeriesAlarmDeleteResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module TimeSeriesAlarmService {

  /**
   * Parameters for TimeSeriesAlarmGetByUri
   */
  export interface TimeSeriesAlarmGetByUriParams {
    uri: string;
    customerId: number;
  }

  /**
   * Parameters for TimeSeriesAlarmDelete
   */
  export interface TimeSeriesAlarmDeleteParams {
    timeSeriesAlarmId?: number;
    customerId?: number;
  }
}

export { TimeSeriesAlarmService }
